module.exports = "/_next/static/images/3a298857c0e0adb33ee2fc16ae38b0e4-debit-card.svg.webp";